enum DonationStatus {
  paid = 'paid',
  reallocated = 'reallocated',
  refunded = 'refunded',
  failed = 'failed',
}

export default DonationStatus
